import script from "./Plus.vue?vue&type=script&setup=true&lang=js"
export * from "./Plus.vue?vue&type=script&setup=true&lang=js"

import "./Plus.vue?vue&type=style&index=0&id=e1edb384&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1edb384"]])

export default __exports__